import styled from 'styled-components';

export const AboutZa = styled.section`

    padding: 3rem 0;

    .container {

        .about-block {

            margin-bottom: 2rem;

            h3 {
                font-size: 1.5rem;
                font-weight: 900;
            }

            p {
                padding: 0.5rem 0;
                font-size: 1.2rem;
                font-weight: 300;
            }

            .values {
                display: flex;
                flex-wrap: wrap;
                margin-top: 0.5rem;

                .value {
                    padding: 1rem 2rem;
                    background-color: ${ props => props.theme.greyColor };
                    margin-bottom: 1rem;
                    margin-right: 1rem;
                    text-align: center;

                    svg {
                        font-size: 1.5rem;
                        color: ${ props => props.theme.primaryColor };
                    }

                    p {
                        font-weight: 500;
                        font-size: 1.2rem;
                    }
                }

                @media (max-width: 500px){

                    .value {
                        width: 100%;
                        margin-right: 0;
                    }

                }
            }

        }

    }

    @media (max-width: 1024px){

        padding: 3rem 1.5rem;

    }

`

export const AboutFounder = styled.section`

    padding: 3rem 0;
    background: ${ props => props.theme.greyColor };

    .container {

        .two-sections {

            display: flex;

            .left-content {
                flex: 1;
                padding: 0 2rem 0 0;

                h2 {
                    font-size: 1.5rem;
                    margin-bottom: 1rem;

                    @media (max-width: 768px){

                        font-size: 2rem;

                    }
                }

                p {
                    font-size: 1.4rem;
                    font-weight: 300;
                    margin-bottom: 1rem;
                }
            }

            .right-content {

                flex: 1;

                background: url('zanelephakathi.png') no-repeat top center/cover;

            }

            @media (max-width: 500px){

                flex-direction: column-reverse;

                .right-content {

                    height: 30rem;
                    flex: none;

                }

                .left-content{

                    flex: none;
                    text-align: center;
                    padding: 0;

                    h2 {

                        margin-top: 1rem;
                        font-size: 1.3rem;

                    }

                }

            }

        }

    }

    @media (max-width: 1024px){

        padding: 3rem 1.5rem;

    }

`